import { Language } from '../enums/Language';

export const languageInfo = new Map([
  [Language.EN, { fullName: 'English', shortName: 'Eng' }],
  [Language.RU, { fullName: 'Russian', shortName: 'Rus' }],
  [Language.FR, { fullName: 'Français', shortName: 'Fr' }],
]);
